































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const a = namespace("a");
@Component({})
export default class HelloWorld extends Vue {
  @Prop({ default: () => "" }) dataValue; // 需要回显的值
  @Prop({ default: false }) disabled; // 是否禁用

  curValue = "";
  @Watch("dataValue", { immediate: true })
  watchDataValue(val) {
    this.curValue = val;
  }
  get firstValue() {
    return this.curValue ? this.curValue[0] : "";
  }
  openMediaDialog() {
    this.$emit("editImages");
  }
  isVideo(value) {
    if (value) {
      let item = value.split(",")[0];
      let type = item.split(".");
      return ["mp4"].includes(type[type.length - 1]);
    } else {
      return false;
    }
  }
}
